interface ConfirmationRequest { message: string; kind: 'confirm' | 'prompt'; resolve: (value: string | boolean | null) => void }
let requests: ConfirmationRequest[] = [];
const listeners = new Set<() => void>();
function publish(): void { listeners.forEach(listener => listener()); }
function enqueue(message: string, kind: ConfirmationRequest['kind']): Promise<string | boolean | null> {
  return new Promise(resolve => { requests = [...requests, { message, kind, resolve }]; publish(); });
}
export async function confirmAction(message: string): Promise<boolean> { return await enqueue(message, 'confirm') === true; }
export async function promptText(message: string): Promise<string | null> { const result = await enqueue(message, 'prompt'); return typeof result === 'string' ? result : null; }
export const confirmationStore = {
  subscribe(this: void, listener: () => void): () => void { listeners.add(listener); return () => { listeners.delete(listener); }; },
  snapshot(this: void): ConfirmationRequest | undefined { return requests[0]; },
  cancelAll(this: void): void { const abandoned = requests; requests = []; abandoned.forEach(request => request.resolve(request.kind === 'prompt' ? null : false)); publish(); },
  finish(request: ConfirmationRequest, value: string | boolean | null): void {
    if (requests[0] !== request) return;
    requests = requests.slice(1); request.resolve(value); publish();
  },
};
